import React, {useEffect, useState} from "react";
import s from './TableContent.module.css'
import {GroupedVirtuoso} from 'react-virtuoso'
import TableContentRowContainer from "./TableContentRow/TableContentRowContainer";
import {useDispatch, useSelector} from "react-redux";
import {
    sendEffectiveBarCodesToServer,
    sendSaleIdsToServer, setDataPrintStatus,
    setRangeAfterLastSelectedRow,
    setRangeAfterLastSelectedRowRegItemsDispatcher, setRangeBeforeLastSelectedRow,
    setRangeBeforeLastSelectedRowRegItemsDispatcher, setSelectedRow, setSelectedRowForPricesTable
} from "../../../../Redux/content-reducer";
import {TableHeaders} from "../TableHeaders/TableHeaders";

export const TableContent = () => {
    const dispatch = useDispatch();
    const {contentData, dropdownsReducer} = useSelector(state => state);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if(contentData.isActivePromosScreen){
            if(contentData.isPrintListOpened){
                setTableData(contentData.printListDataForPromos);
            } else {
                setTableData(contentData.data);
            }
        } else {
            if(contentData.isPrintListOpened){
                setTableData(contentData.printListDataForItems);
            } else {
                setTableData(contentData.dataForRegPrices);
            }
        }
    }, [
        contentData.isPrintListOpened,
        contentData.isPreloader,
        contentData.dataForRegPrices,
        contentData.printListDataForItems,
        contentData.data,
        contentData.printListDataForPromos,
        contentData.isActivePromosScreen
    ]);


    const getSelectedRangeRows = (indexForEndRange, targetInput) => {
        const data = [...tableData];
        // eslint-disable-next-line array-callback-return
        const lastSelectedRow = data.filter(key => {
            if (key.isLastSelected) {
                return key;
            }
        });
        const lastSelectedRowIndex = lastSelectedRow.length ? lastSelectedRow[0].rowIndex : indexForEndRange;
        if(contentData.isActivePromosScreen){
            if(indexForEndRange > lastSelectedRowIndex){
                dispatch(setRangeAfterLastSelectedRow(lastSelectedRowIndex, indexForEndRange));
            } else if(indexForEndRange < lastSelectedRowIndex){
                dispatch(setRangeBeforeLastSelectedRow(lastSelectedRowIndex, indexForEndRange));
            } else {
                let isChecked = targetInput.checked, isLastSelected = targetInput.checked;
                const saleId = Number(targetInput.parentNode.parentNode.dataset.saleid);
                dispatch(setSelectedRow(isChecked, Number(saleId), isLastSelected));
            }
        } else {
            if (indexForEndRange > lastSelectedRowIndex) {
                dispatch(setRangeAfterLastSelectedRowRegItemsDispatcher(lastSelectedRowIndex, indexForEndRange));
            } else if (indexForEndRange < lastSelectedRowIndex) {
                dispatch(setRangeBeforeLastSelectedRowRegItemsDispatcher(lastSelectedRowIndex, indexForEndRange));
            } else {
                let isChecked = targetInput.checked, isLastSelected = targetInput.checked;
                const effectiveBarCode = Number(targetInput.parentNode.parentNode.dataset.effectivebarcode);
                dispatch(setSelectedRowForPricesTable(isChecked, effectiveBarCode, isLastSelected));
            }
        }
    };
    if (contentData.isDataPrintForIcon) {
        const onAfterPrint = () => {
            const format = dropdownsReducer.format;
            const selectedRowsIds = contentData.selectedIds;
            const branchNo = localStorage.getItem('selectedOptionValue');
            if(contentData.isActivePromosScreen){
                dispatch(sendSaleIdsToServer(branchNo, format, selectedRowsIds));
            } else {
                dispatch(sendEffectiveBarCodesToServer(branchNo, format, selectedRowsIds));
            }
        };
        const a = window.open('', '');
        if (a) {
            a.document.write(contentData.dataPrint);
            a.onafterprint = onAfterPrint;
            dispatch(setDataPrintStatus(false));
        }
    }

    return (
        <div className={s.tableContent}>
            <GroupedVirtuoso
                className={`virtuoso`}
                groupCounts={[tableData.length]}
                style={{height: '100%'}}
                groupContent={index => {
                    return (
                        <>
                            <TableHeaders/>
                        </>
                    )
                }}
                itemContent={
                    (index, groupIndex) => {
                        return <TableContentRowContainer
                            key={tableData[index].rowIndex}
                            dataRow={tableData[index]}
                            dataRows={tableData}
                            getSelectedRangeRows={getSelectedRangeRows}
                        />
                    }
                }
            />
        </div>
    )
}